<template>
  <GModal ref="modalUserPhotos" class="modal--user-photos">
    <div slot="header">
      <button type="button" class="close" aria-label="Close">
        <img src="/assets/img/icons/close-modal.svg" alt="SOCO" @click.prevent="closeModal" />
      </button>

      <h2 class="modal-heading">User Photos ({{ totalUserPhoto }})</h2>
    </div>

    <div slot="body">
      <UserPhotosSlide key="UserPhotosSlide" />
    </div>
  </GModal>
</template>

<script>
import UserPhotosSlide from '@/components/product/product-detail/snippet/user-photos-slide';

export default {
  name: 'modal-user-photos',
  components: {
    UserPhotosSlide,
  },
  computed: {
    totalUserPhoto() {
      return this.$store.state.productDetail.totalUserPhoto;
    },
  },
  methods: {
    closeModal() {
      this.$store.commit('setModalUserPhotos', false);
    },
  },
};
</script>
